import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import variables from "../../../../../../assets/styles/sass-resources.scss";
import config from "appConfig";

const principle: Slide = {
  description:
    "This part demonstrates an audiovisual illusion, the McGurk effect. Please play the video below. If you focus on the left speaker, you will hear the series of morphemes “ba ba ba”. If you focus on the right speaker, you might here something different, even though the sound does not change.",
  theory: theory,
  layout: {
    type: "table",
    options: {
      cols: 1,
      rows: 2,
      rowsSize: [1, 5],
      components: [
        [
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  data: "Missing fundamental",
                  scrollbars: false,
                  styles: {
                    fontWeight: 800,
                    letterSpacing: "0.25em",
                    textTransform: "uppercase",
                  },
                },
              },
            },
          },
        ],
        [
          {
            variant: "layout",
            data: {
              type: "simple",
              options: {
                components: {
                  variant: "layout",
                  data: {
                    type: "table",
                    options: {
                      cols: 3,
                      rows: 3,
                      colSpan: {
                        "0:0": 3,
                        "2:0": 3,
                      },
                      colsSize: [2, 1, 2],
                      components: [
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "text",
                                options: {
                                  data:
                                    "<span style='font-size:18px; font-weight:700'>f<sub>0</sub> = 30 Hz</span><br><span style='font-size:10px;'>(missing fundamental)</span>",
                                  scrollbars: false,
                                  styles: {
                                    lineHeight: "20px",
                                    textAlign: "center",
                                  },
                                },
                              },
                              styles: {
                                alignItems: "flex-end",
                              },
                            },
                          },
                        ],
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "audioButton",
                                options: {
                                  text: "2f<sub>0</sub>",
                                  icon: "cis-volume-high",
                                  shape: "round",
                                  theme: "primary",
                                  url: `${config.ASSETS_URL}/02/30/principle/2f0.wav`,
                                },
                              },
                              styles: {
                                justifyContent: "flex-end",
                              },
                            },
                          },
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "audioButton",
                                options: {
                                  text: "3f<sub>0</sub>",
                                  icon: "cis-volume-high",
                                  shape: "round",
                                  theme: "primary",
                                  url: `${config.ASSETS_URL}/02/30/principle/3f0.wav`,
                                },
                              },
                            },
                          },
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "audioButton",
                                options: {
                                  text: "2f<sub>0</sub> + 3f<sub>0</sub>",
                                  icon: "cis-volume-high",
                                  shape: "round",
                                  theme: "primary",
                                  url: `${config.ASSETS_URL}/02/30/principle/2f0-3f0.wav`,
                                },
                              },
                              styles: {
                                justifyContent: "flex-start",
                              },
                            },
                          },
                        ],
                        [
                          {
                            variant: "blockContainer",
                            data: {
                              block: {
                                type: "hint",
                                options: {
                                  direction: "row",
                                  color: "primary",
                                  data:
                                    "When both signals are added, the missing<br>fundamental at f<sub>0</sub> = 30 Hz appears audible<br>despite not being present in the signal.",
                                },
                              },
                              styles: {
                                alignItems: "flex-start",
                              },
                            },
                          },
                        ],
                      ],
                    },
                    styles: {
                      border: `1px solid ${variables["text-primary"]}`,
                      boxShadow: `0 2px 0 ${variables["text-primary"]}`,
                      borderRadius: "10px",
                    },
                  },
                },
              },
              styles: {
                padding: "3% 5%",
              },
            },
          },
        ],
      ],
    },
  },
};

export default principle;
